import React from 'react';
import './NewGameOptionsModal.css';
// Ensure Font Awesome is linked in your public/index.html for icons

function NewGameOptionsModal({
  onRestartRound, // This prop might become unused, but keep it for now if other logic depends on it
  onSelectNewRound,
  onChangeRoundKeepBalls,
  onGoHome,
  onClose
}) {
  return (
    <div className="new-game-options-overlay" onClick={onClose}>
      <div className="new-game-options-modal" onClick={(e) => e.stopPropagation()}>
        <h2>What's Next?</h2>
        <p className="modal-subtitle">Choose an option to continue:</p>
        <div className="new-game-options-buttons">
          <button
            onClick={onChangeRoundKeepBalls}
            className="new-game-option-button change-round-keep-balls"
          >
            <i className="fas fa-random button-icon"></i>
            <div className="button-text-content">
              <span className="button-main-title">New Sheets</span>
              <span className="button-subtitle">KEEP balls - new round.</span>
            </div>
          </button>
          <button
            onClick={onSelectNewRound}
            className="new-game-option-button select-new-round"
          >
            <i className="fas fa-plus-circle button-icon"></i>
            <div className="button-text-content">
              <span className="button-main-title">New Game</span>
              <span className="button-subtitle">New round - RESET balls.</span>
            </div>
          </button>
          {/* Removed the "Restart Game" button */}
        </div>
        <button
          onClick={onGoHome}
          className="new-game-option-button go-home subtle-home-button"
        >
          <i className="fas fa-home button-icon"></i>
          <div className="button-text-content">
            <span className="button-main-title">Go Home</span>
            <span className="button-subtitle">Back to the main screen.</span>
          </div>
        </button>
        <button className="cancel-new-game-options-button" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default NewGameOptionsModal;